<nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white">
  <div class="container-fluid">

    <!-- Toggler -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidebarCollapse"
      aria-controls="sidebarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapse -->
    <div class="collapse navbar-collapse" id="sidebarCollapse">

      <h6 class="navbar-heading">
        Documentation
      </h6>

      <!-- Navigation -->
      <ul class="navbar-nav">

        <!-- @insert_generated_views -->

        <li class="nav-item">
          <a class="nav-link" [class.active]="document == 'cockpit'" (click)="navigate('cockpit')">
            <i class="fe fe-rss"></i> Cockpit
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="document == 'einstellungen'" (click)="navigate('einstellungen')">
            <i class="fe fe-rss"></i> Einstellungen
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="document == 'zugriffsrechte'" (click)="navigate('zugriffsrechte')">
            <i class="fe fe-rss"></i> Zugriffsrechte
          </a>
        </li>
      </ul>

    </div> <!-- / .navbar-collapse -->
  </div> <!-- / .container-fluid -->
</nav>

<div id="doc-container">
  <div class="main-content pt-5 pb-5">
    <div class="container-fluid">
      <markdown [src]="'assets/docs/' + document + '.md'">
      </markdown>
    </div>
  </div>

</div>